'use strict'

function callModal(dataModal) {
  var modalDiv = $('#js-message')
  modalDiv.find('.modal-title').html(dataModal['header'])
  modalDiv.find('.modal-body').html(dataModal['body'])
  modalDiv.find('.modal-footer').html(dataModal['footer'])
  modalDiv.modal()
}

function scrollWindow(id, speed) {
  var page = $('html, body')

  var header = 0

  page.on(
    'scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove',
    function() {
      page.stop()
    }
  )

  page.animate({ scrollTop: $(id).offset().top - header }, speed, function() {
    page.off('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove')
  })
}

function toggleMenu(targetBtn, targetMenu) {
  var isMenuOpen, isBtnOpen

  isBtnOpen = targetBtn.data('is-open')
  isMenuOpen = targetMenu.data('is-open')

  if (!isMenuOpen && !isBtnOpen) {
    targetMenu.addClass('menu--is-open')
    targetBtn.addClass('btn-menu--is-open')

    targetBtn.data('is-open', 1)
    targetMenu.data('is-open', 1)
  } else {
    targetMenu.removeClass('menu--is-open')
    targetBtn.removeClass('btn-menu--is-open')

    targetBtn.data('is-open', 0)
    targetMenu.data('is-open', 0)
  }
}

function findBigHeight(id) {
  var eventHeight = []
  $(id).each(function(index, el) {
    eventHeight.push(parseInt($(el).height()))
  })
  eventHeight = eventHeight.sort(function(a, b) {
    return b - a
  })
  return eventHeight[0]
}

$(function() {
  $('.js-map').click(function() {
    $(this)
      .find('iframe')
      .toggleClass('scroll-off')
  })
  $('.js-map').on('mouseleave', function() {
    $(this)
      .find('iframe')
      .addClass('scroll-off')
  })
})

$(function() {
  $(document).on('click', '#__bs_notify__', function(event) {
    event.preventDefault()
    $(this).remove() /* Act on the event */
  })
})

$(function() {
  var d = new Date()
  $('.js-actual-year').append(d.getFullYear())
})

function detectIE() {
  var ua = window.navigator.userAgent
  var msie = ua.indexOf('MSIE ')
  if (msie > 0) {
    /* IE 10 or older => return version number*/
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10)
  }

  var trident = ua.indexOf('Trident/')
  if (trident > 0) {
    /* IE 11 => return version number */
    var rv = ua.indexOf('rv:')
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10)
  }
  /* other browser */
  return false
}

function accordion(el) {
  var parent = document.querySelector(el)
  var items = Array.from(parent.children)
  this.isToggle = false

  items.forEach(item => {
    item.addEventListener('click', toggle)
  })

  function toggle() {
    if (!this.isToggle) {
      this.classList.add('accordion__item--active')
      this.querySelector('.js-accordion__icon--plus').style.display = 'none'
      this.querySelector('.js-accordion__icon--minus').style.display = 'block'
      this.querySelector('.js-accordion__body').style.display = 'block'
      this.isToggle = true
    } else {
      this.classList.remove('accordion__item--active')
      this.querySelector('.js-accordion__icon--plus').style.display = 'block'
      this.querySelector('.js-accordion__icon--minus').style.display = 'none'
      this.querySelector('.js-accordion__body').style.display = 'none'
      this.isToggle = false
    }
  }
}

function company() {
  var parent = document.querySelector('.js-company__info-grid')

  // var items = Array.from(parent.children)
  var items = []
  for (let i = 0; i < parent.children.length; i++) {

    for (let j = 0; j < parent.children[i].children.length; j++) {
      var item = parent.children[i].children[j]
      item.addEventListener('click', toggle)
      items.push(item)
    }
  }

  this.isToggle = false

  function toggle() {
    if (!this.isToggle) {
      this.classList.add('company-detail--active')
      this.querySelector('.js-company-detail__icon--plus').style.display =
        'none'
      this.querySelector('.js-company-detail__icon--minus').style.display =
        'block'
      this.querySelector('.js-company-detail__body').style.display = 'block'
      this.isToggle = true
    } else {
      this.classList.remove('company-detail--active')
      this.querySelector('.js-company-detail__icon--plus').style.display =
        'block'
      this.querySelector('.js-company-detail__icon--minus').style.display =
        'none'
      this.querySelector('.js-company-detail__body').style.display = 'none'
      this.isToggle = false
    }
  }
}


function calcTableHeight() {
  var el = $('.js-p-product-detail__table')
  var caclHeight = el.height()
  var elTr = el
    .children('table')
    .children('tbody')
    .children('tr')
  var countTable = elTr.length
  var heightTr = caclHeight / countTable

  elTr.children('td').css('height', heightTr)
}